import { AnyObject } from '@vimeo/core/types/generic';

import { ELiveErrorCode } from '../../types/error';

/**
 * Error specific to live app.
 * Gets additional fields with report information and tracked differently by new relic.
 */
export class LiveError<T extends AnyObject = AnyObject> extends Error {
  public override name: string = 'LiveError';
  public code: ELiveErrorCode | string;
  public data: T = {} as T;

  /**
   * @param message - generic message describing error
   * @param config - error object configuration object
   * @param config.code - error code describing category/group of error
   * @param config.data - additional information about root cause
   */
  public constructor(
    message: string,
    {
      code = ELiveErrorCode.GENERIC,
      data = {} as T,
    }: { code?: ELiveErrorCode | string; data?: T } = {},
  ) {
    super(message);

    this.code = code;

    Object.assign(this.data, data);
  }
}
